import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLiveConvention,
  getConventionSelector,
} from "../../../store/conventionSlice";

/**
 * @desc Custom hook for fetching convention data by brand.
 */
export const useFetchConventionData = (brand) => {
  // CONSTANTS ----------------------------------------------------------------

  const dispatch = useDispatch();
  const convention = useSelector(getConventionSelector);

  // SIDE EFFECTS -------------------------------------------------------------

  /**
   * @desc Only once, fetch convention data.
   */
  useEffect(() => {
    if (brand) {
      dispatch(fetchLiveConvention(brand));
    }
  }, [brand, dispatch]);

  // HOOK ---------------------------------------------------------------------

  return {
    convention,
  };
};
